import React from "react";
import GrComponentFactory from "../gr_component_factory";
import GrPropTypes from "../shared/gr_prop_types";
import RelativeTime from "../../react_components/time/relative_time";

export default GrComponentFactory.createClass({
  displayName: "NewsfeedItemHeaderTimestamp",

  propTypes: {
    time: GrPropTypes.date.isRequired,
    resourceDisplayName: React.PropTypes.string,
    resourceUrl: React.PropTypes.string,
  },

  linkExists() {
    return this.props.resourceDisplayName && this.props.resourceUrl;
  },

  renderTimestamp() {
    if (this.linkExists()) {
      return (
        <a
          href={this.props.resourceUrl}
          className="gr-hyperlink gr-hyperlink--naked"
          aria-label={`Permanent link to ${this.props.resourceDisplayName}`}
          >
          <RelativeTime time={this.props.time} />
        </a>
      );
    } else {
      return (
        <span>
          <RelativeTime time={this.props.time} />
        </span>
      );
    }
  },

  render() {
    return (
      <small className="gr-newsfeedItem__headerTimestamp">
        {this.renderTimestamp()}
      </small>
    );
  },
});
